import { useSessionRole } from "@/entities/session"
import { PostEditor } from "@/features/edit-post"
import { AccessDenied } from "@/shared/ui/access-denied"

/** Новый материал. Сохраняется черновиком и открывается на экране публикации. */
export function CreatePostPage() {
	const { isAdmin } = useSessionRole()
	if (!isAdmin) return <AccessDenied title="Новый материал" />
	return <PostEditor />
}
